// Test IDs for the pitch-deck feature. Keys camelCase, values kebab-case.

export const DECK = {
  // global
  preloader: 'preloader',
  scrollProgress: 'scroll-progress',
  chapterRail: 'chapter-rail',
  stickySkullStage: 'sticky-skull-stage',
  enterButton: 'enter-button',
  // segments
  segmentColdOpen: 'segment-cold-open',
  segmentLogline: 'segment-logline',
  segmentSynopsis: 'segment-synopsis',
  segmentNightWater: 'segment-night-on-the-water',
  segmentTheBullet: 'segment-the-bullet',
  segmentPandi: 'segment-pandi',
  segmentProtagonistReel: 'segment-protagonist-reel',
  segmentFishermanGirl: 'segment-fisherman-girl',
  segmentSagayamsSister: 'segment-sagayams-sister',
  segmentHiddenFew: 'segment-hidden-few',
  segmentAkrEmpire: 'segment-akr-empire',
  segmentPolice: 'segment-police',
  segmentManInsideSystem: 'segment-man-inside-system',
  segmentDirectorsVision: 'segment-directors-vision',
  segmentTheDirector: 'segment-the-director',
  segmentDirectorCredits: 'segment-director-credits',
  segmentVisualTreatment: 'segment-visual-treatment',
  segmentMoodboard: 'segment-moodboard',
  segmentWorldMoodboard: 'segment-world-moodboard',
  segmentMarketAudience: 'segment-market-audience',
  segmentProduction: 'segment-production',
  segmentContactCta: 'segment-contact-cta',
  // form
  inquiryForm: 'inquiry-form',
  inquiryName: 'inquiry-name-input',
  inquiryEmail: 'inquiry-email-input',
  inquiryCompany: 'inquiry-company-input',
  inquiryRole: 'inquiry-role-input',
  inquiryMessage: 'inquiry-message-textarea',
  inquirySubmit: 'inquiry-submit-button',
  inquirySuccess: 'inquiry-success-message',
  inquiryError: 'inquiry-error-message',
};
